import loadable from '@loadable/component';
import ChannelComponentWrapper from './ChannelComponentWrapper';
import { CHANNEL } from 'domains/landing-autos/enums/channel';

const BCPComponent = loadable(
  () => import('../domains/auto-efectivo/bcp/payment/containers/app'),
);
const YapeComponent = loadable(
  () =>
    import('../domains/auto-efectivo/remarketing/payment/containers/app-yape'),
);
const DefaultComponent = loadable(
  () => import('../domains/quotation/containers/confirmation/confirmation'),
);

const channelComponentMap = {
  [CHANNEL.BCP_AUTOEFECTIVO]: BCPComponent,
  [CHANNEL.YAPE_AUTOEFECTIVO]: YapeComponent,
};

const SummaryPageWrapper = () => (
  <ChannelComponentWrapper
    channelComponentMap={channelComponentMap}
    defaultComponent={DefaultComponent}
  />
);

export default SummaryPageWrapper;
